<template>
  <div class="ac-body-container">
    <div class="plan-header-container">
      <div>
        <div class="main-header-setting">
          <div class="flex-row align-center top-header">
            Smart Maintenance&reg;
            <button
              v-if="plans.length > 0"
              type="button"
              class="ac-info-btn"
              @click="toggleInfoModal(true, 'smart-maintenance')"
            >
              <img
                src="@shared/assets/img/general/question-white.svg"
                alt="question"
              />
            </button>
          </div>
        </div>
        <div class="sub-header-setting">
          Smart Maintenance&reg; offers partners a way to enhance their existing
          membership plans.
        </div>
      </div>
    </div>
    <div v-if="plans.length > 0" class="ac-plan-count-parent-container">
      <div class="ac-plan-count-container">
        <div class="ac-plan-count-container-header">
          Total Members on Smart Maintenance&reg;
        </div>
        <div class="ac-plan-member-number">
          {{ totalActiveMembers }}
        </div>
      </div>
      <div class="ac-plan-count-container">
        <div class="ac-plan-count-container-header">
          Maintenance Plans Offered
        </div>
        <div class="ac-plan-count-number">
          {{ numPlanOffered }}
        </div>
      </div>
    </div>
    <div v-if="plans.length === 0" class="ac-section-container">
      <div class="ac-section-header-container">
        <div class="ac-section-header">Plan Builder</div>
        <div v-if="adminRole !== 'viewer'">
          <button
            type="button"
            class="new-plan-btn"
            @click="toggleActionModal(true, 'plan-builder')"
          >
            Start Building my Plans
          </button>
        </div>
      </div>
      <div class="plan-body-container">
        <div class="ac-plan-container">
          <div class="ac-plan-header">
            <img src="@shared/assets/img/setting/plan-icon.svg" alt="plan" />
            Create custom serviced plans
          </div>
          <div class="ac-plan-body">
            Easily incorporate SmartAC.com to your maintenance plan offerings.
          </div>
        </div>
        <div class="ac-plan-container">
          <div class="ac-plan-header">
            <img
              src="@shared/assets/img/setting/cc-full-icon.svg"
              alt="Comfort Credits"
            />
            Comfort Credits
          </div>
          <div class="ac-plan-body">
            Customize special offers when homeowners sign up for maintenance
            plans. Credits accumulate over time encouraging customer loyalty
          </div>
        </div>
        <div class="ac-plan-container">
          <div class="ac-plan-header">
            <img
              src="@shared/assets/img/setting/signup-icon.svg"
              alt="Sign Up Bonus"
            />
            Sign Up Bonuses
          </div>
          <div class="ac-plan-body">
            Add sign up bonuses to your plans, such as Comfort Credits and
            Filter Discount Vouchers, as an incentive for your customers
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ac-section-container">
        <div class="ac-section-header-container">
          <div class="ac-section-header">My Plans</div>
          <button
            type="button"
            class="sac__button bg-primary"
            @click="toggleActionModal(true, 'plan-builder')"
          >
            Add New
          </button>
        </div>
        <div class="ac-plans-container">
          <div
            v-for="plan in sortedPlans"
            :key="plan.planId"
            class="ac-plan-wrapper"
          >
            <PlanCard
              :plan="plan"
              :toggleLocalActionModal="toggleLocalActionModal"
              :partnerSettings="partnerSettings"
              :currentPath="currentPath"
            />
            <div class="flex-row align-center">
              <div class="ac-plan-details-count">
                <div
                  v-if="plan.status === 'Archived'"
                  class="flex-column sac__font-11_400"
                >
                  <span>{{ plan.name }}</span>
                  <span>(Archived {{ getDateV2(plan.updateDate) }})</span>
                </div>
                <span v-else>{{ plan.name }}</span>
                <span>{{ plan.activeMembers }}</span>
              </div>
            </div>
            <div class="flex-row align-center">
              <div class="ac-plan-details-count">
                <span>{{
                  plan.planType?.toLowerCase() === 'apponly'
                    ? 'Connect'
                    : 'Detect'
                }}</span>
                <span>{{
                  plan.planType?.toLowerCase() === 'apponly'
                    ? 'App-only'
                    : 'Hardware'
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InfoModal
      :infoModalView="infoModalView"
      :showInfoModal="showInfoModal"
      :plan="selectedPlan"
      :close="() => toggleInfoModal(false)"
    />
    <ActionModal
      :actionModalView="actionModalView"
      :showActionModal="showActionModal"
      :close="() => toggleLocalActionModal(false)"
      :updatePlanStatus="updatePlanStatus"
      :updatingPlan="updatingPlan"
      :partnerPSM="partnerPSM"
      :selectedPlan="selectedPlan"
      :partnerSettings="partnerSettings"
      :partner="currentCorporation"
      :isSmacAdmin="isSmacAdmin"
      :toggleLocalActionModal="toggleLocalActionModal"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import formatterMixin from '@shared/mixins/formatterMixin';

import PlanCard from './providerPlan/PlanCard.vue';
import InfoModal from './providerPlan/InfoModal.vue';
import ActionModal from './providerPlan/ActionModal.vue';

export default {
  name: 'ProviderPlan',
  components: {
    PlanCard,
    InfoModal,
    ActionModal,
  },
  mixins: [partnerSettingsMixin, formatterMixin],
  props: {
    partnerSettings: Object,
    currentCorporation: Object,
    plans: Array,
    toggleActionModal: Function,
    update: Function,
  },
  data() {
    return {
      showInfoModal: false,
      infoModalView: '',
      showActionModal: false,
      actionModalView: '',
      updatingPlan: false,
    };
  },
  computed: {
    sortedPlans() {
      const sorted = this.plans.slice();
      sorted.sort((a, b) => {
        if (a.status === 'Active' && b.status !== 'Active') {
          return -1;
        }
        if (b.status === 'Active' && a.status !== 'Active') {
          return 1;
        }
        return 0;
      });
      return sorted;
    },
    currentPath() {
      return this.$route.path;
    },
    partnerPSM() {
      const { psmList } = this.$store.state.setting;
      return psmList.find((psm) => psm.id === this.currentCorporation.psmId);
    },
    totalActiveMembers() {
      return this.plans.reduce(
        (sum, plan) => sum + (plan.activeMembers || 0),
        0
      );
    },
    numPlanOffered() {
      return this.plans.reduce((acc, p) => {
        let sum = acc;
        if (p.status?.toLowerCase() === 'active') {
          sum += 1;
        }
        return sum;
      }, 0);
    },
  },
  mounted() {
    this.$store.dispatch('getAdminPSMList');
  },
  methods: {
    toggleInfoModal(show, view) {
      if (show) {
        this.showInfoModal = show;
        this.infoModalView = view;
      } else {
        this.showInfoModal = show;
      }
    },
    toggleLocalActionModal(plan, show, view) {
      if (show) {
        this.showActionModal = show;
        this.actionModalView = view;
        this.changePartnerSettingsValue('selectedPlan', plan);
      } else {
        this.showActionModal = show;
        this.changePartnerSettingsValue('selectedPlan', null);
      }
    },
    async updatePlanStatus(status) {
      const { planId, name } = this.selectedPlan;
      const updatePlan = {
        ...this.selectedPlan,
        status,
      };
      this.updatingPlan = true;
      try {
        await this.$store.dispatch('updatePlanStatus', updatePlan);
        let message = `Success! Your ${name} has updated`;
        if (status === 'Archived') {
          if (this.partnerSettings?.PREFERRED_PLAN_ID === planId) {
            const unprefered = {
              PREFERRED_PLAN_ID: null,
            };
            await this.update(unprefered);
          }
          message = `Success! ${name} plan has been archived`;
        } else if (status === 'Active') {
          message = `Success! ${name} plan has been set to active`;
        } else if (status === 'Deleted') {
          message = `Success! ${name} plan has been deleted`;
        }
        this.updatingPlan = false;
        this.$store.dispatch('showSuccessToast', {
          message,
        });
        this.toggleLocalActionModal(false);
        this.changePartnerSettingsValue('selectedPlan', null);
      } catch (err) {
        console.error(err);
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error updating plan. Please try again or contact support',
        });
        this.updatingPlan = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;

  .plan-header {
    display: flex;
    align-items: center;
    font-size: 1.5625rem;
    color: $N100;
    font-weight: 600;
    font-size: 18px;
  }
}

.plan-body-container {
  background-color: $WHITE;
  box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
  border-radius: 6px;
  padding-bottom: 12px;
  display: flex;

  .ac-plan-container {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 1px solid $N5;
    border-radius: 6px;
    padding: 13px 23px;

    &:not(:last-child) {
      margin-right: 12px;
    }

    .ac-plan-header {
      display: flex;
      align-items: center;
      font-size: 1rem;
      font-weight: 400;
      color: $NAVY100;

      img {
        margin-right: 11px;
      }
    }

    .ac-plan-body {
      margin-top: 8px;
      font-size: 0.6875rem;
      color: $N90;
      text-align: center;
    }
  }
}

.edit-btn {
  background: $NBLUE100;
  padding: 8px;
  border-radius: 8px;
  width: 155px;
  color: $WHITE;
  font-weight: bold;
}

.top-header {
  font-size: 28px;
  font-weight: 500;
}

.sub-header-setting {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.ac-info-btn {
  width: 24px;
  height: 24px;
  background-color: $N90;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.12);
  margin-bottom: 4px;
}

.ac-info-grey-btn {
  width: 16px;
  height: 16px;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.12);
}

.ac-plan-count-parent-container {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.ac-plan-count-number {
  color: $TEXT_SECONDARY;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
}

.ac-plan-member-number {
  color: $BLACK;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
}

.ac-plan-count-container-header {
  line-height: 1;
}

.ac-plan-count-container {
  background-color: $GRAY_80;
  box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
  border-radius: 8px;
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
}

.ac-plan-details-count {
  display: flex;
  width: 240px;
  height: 40px;
  padding: 4px 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background-color: $SURFACES_PRIMARY;
  margin-right: 10px;
  margin-top: 16px;
}

.ac-plan-container {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid $N5;
  border-radius: 6px;
  padding: 13px 23px;

  &:not(:last-child) {
    margin-right: 12px;
  }

  .ac-plan-header {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
    color: $NAVY100;

    img {
      margin-right: 11px;
    }
  }

  .ac-plan-body {
    margin-top: 8px;
    font-size: 0.6875rem;
    color: $N90;
    text-align: center;
  }
}

.ac-plans-container {
  background-image: url('@shared/assets/img/setting/plan-popup-bg.png');
  background-size: cover;
  display: flex;
  align-items: center;
  padding: 24px 59px 0;
  overflow-x: auto;
  max-width: calc(90vw - 258px);
  padding: 20px;

  .ac-plan-wrapper {
    height: 100%;
    padding-bottom: 26px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:not(:last-child) {
      margin-right: 49px;
    }

    .plan-card-container {
      width: 200px;
    }

    .ac-plan-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      width: 60px;
      border-radius: 3px;
      margin-top: 12px;
      font-size: 0.625rem;
      font-weight: 500;
      line-height: 1;

      &:not(:last-child) {
        margin-right: 12px;
      }

      &.green {
        background-color: $LIGHT_MINT !important;
      }

      &.light-blue {
        background-color: #cad7ff !important;
        color: $N90 !important;
      }

      &.blue {
        background-color: $NBLUE100 !important;
        color: $WHITE !important;
      }

      &.red {
        background-color: $PUNCH !important;
        color: $WHITE !important;
      }
    }
  }
}

.ac-section-container {
  border: 1px solid $N10;
  border-radius: 8px;
  padding: 20px;
  .ac-section-header-container {
    border-bottom: 1px solid $N10;
    padding-bottom: 18px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ac-section-header {
      font-weight: 600;
      font-size: 18px;
    }
    .new-plan-btn {
      width: 200px;
      height: 40px;
      background-color: $NBLUE100;
      text-align: center;
      color: $WHITE;
      font-weight: 600;
      font-size: 15px;
      line-height: 15px;
      border-radius: 8px;
    }
  }
}
</style>
